<template lang="pug">
      v-dialog.d-print-none.elevation-0( flat v-model='dialog' max-higth='500px' persistent)
        template(v-slot:activator='{ on }')
          v-btn(color='secondary' icon v-on='on' @click='ver_propuestas(idCotizacion)')
            v-icon(small) far fa-eye
        v-card.elevation-0(flat)
          v-card-text
            v-container#evaluacion_de_cotizaciones.py-5
              v-card-title 
                span Informe de Cotización Nº {{Datos.numero_de_operacion}}
                v-spacer
                Boton_imprimir( nombre_de_impresion='evaluacion_de_cotizaciones')
                v-btn(color='blue darken-1' icon @click='dialog=false') 
                  v-icon( small) fa-times
              v-card-text Se han recibido las siguientes propuestas:
              v-data-table.elevation-0.my-5( :headers='encabezados_con_proveedor' :footer-props="footerProps" hide-default-footer :items='Propuestas' item-key='numeracion' )
                template( v-slot:item="{ item }")
                  tr
                    td {{item.numeracion}}
                    td {{item.descripcion}}
                    td {{item.cantidad}}
                    template( v-for='proveedor, p of Proveedores' ) 
                      td 
                        span(v-if='item[proveedor] && typeof item[proveedor] === "number" || (typeof item[proveedor] === "string" && !item[proveedor].includes("http") &&  !item[proveedor].includes("ID:"))') {{item[proveedor]}}
                        v-btn(v-if='item[proveedor] && typeof item[proveedor] === "string" && item[proveedor].includes("http")' :href='item[proveedor]' target='_blank' color='primary' icon) 
                          v-icon fa-download
                        Notificar_por_whatsapp_button(v-if='item[proveedor] && typeof item[proveedor] === "string" && item[proveedor].includes("ID:")' 
                          texto='Ha recibido una cotización'
                          :id='item[proveedor].slice(3)'
                          cotizacion
                          :idCotizacion = 'Datos.idCotizacion'
                        ) 
                         
                        

            v-card-actions.d-print-none(justify='center')
              v-spacer
              v-dialog(v-model='provedor_dialog' scrollable max-width='400px')
                template(v-slot:activator='{ on }')
                  v-btn(color='primary' dark v-on='on' :disabled ='Datos.estado_del_documento == "proveedor_seleccionado"'  ) Seleccione proveedor
                  v-btn(color='primary' dark  @click='dialog=false'  ) Cerrar
                v-card
                  v-card-title Elige a tu proveedor
                  v-divider
                  v-card-text(style='height: 300px;') 
                    v-radio-group(v-model='Datos.proveedor_seleccionado' column=''  )
                      v-radio( v-for='proveedor, index in proveedores_de_propuesta' :key='index' :value='proveedor' :label='proveedor.proveedor.name') 
                  v-divider
                  v-card-actions
                    v-btn(color='blue darken-1' text @click='dialog=false;') Cerrar
                    v-btn(color='blue darken-1' text @click='generar_compra({datos:Datos.proveedor_seleccionado,idCotizacion}),dialog=false') Guardar
              
  
</template>
<script>
import {db} from '@/FirebaseConfig'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
    data: () => ({
        dialog:false,
        provedor_dialog: false,
        provedor_dialog_whatsapp: false,
        archivos_dialog: false,
        headers: [
            { text: 'Nº', value: 'numeracion'},
            { text: 'Lista de productos',  value: 'descripcion' },
            { text: 'Cantidad',  value: 'cantidad' },
        ],
         footerProps: {
          'items-per-page-options':  [-1]
        },
    }),
    props:{
      idCotizacion:String,
    },
  
    methods:{
      ...mapActions({
        generar_compra: 'Ordenes_de_compra/add',
        ver_propuestas: 'Cotizaciones/ver_propuestas',
      }),
      
    },

    computed:{
      encabezados_con_proveedor(){
        const headers_copy = [...this.headers]
        this.Proveedores.map(item => headers_copy.push({text: item, value: item}))
        return headers_copy
      },
      ...mapGetters({
        Propuestas: 'Cotizaciones/propuestas',
        Proveedores:'Cotizaciones/proveedores',
        proveedores_de_propuesta: 'Cotizaciones/proveedores_de_propuesta'
      }),
      ...mapState({
        Datos: state=> state.Cotizaciones.datos,
        Cotizaciones :state=> state.Cotizaciones,
      })
    },
    components: {
      Notificar_por_whatsapp_button: ()=>import('./notificar_por_whatsapp_button'),
      Boton_imprimir: ()=>import('@/components/boton_imprimir')
    }
}

</script>